import React from 'react';
import InvestorMenuLink from 'components/Models/InvestorMenuLink/InvestorMenuLink';
import InvestorLinkButton from 'components/InvestorLinkButton';
import PropTypes from 'prop-types';
import cn from 'classnames';
import './InvestorMainMenuMobile.scss';

class InvestorMainMenuMobile extends React.PureComponent {
    render() {
        const { links, className } = this.props;

        if (!links || links.length === 0) return null;

        return (
            <nav className={cn('investor-main-menu-mobile', className)}>
                <ul className="investor-main-menu-mobile__list">
                    {links.map((link, index) => (
                        <li key={index} className="investor-main-menu-mobile__item">
                            <InvestorLinkButton
                                url={link.url}
                                text={link.linkText}
                                className={cn('investor-main-menu-mobile__link', {
                                    'investor-main-menu-mobile__link_active': link.isActive,
                                })}
                                rightIconName="arrow-line-right"
                            />
                        </li>
                    ))}
                </ul>
            </nav>
        );
    }
}

InvestorMainMenuMobile.propTypes = {
    className: PropTypes.string,
    links: PropTypes.arrayOf(PropTypes.shape(InvestorMenuLink.propTypes)).isRequired,
};

export default InvestorMainMenuMobile;



// WEBPACK FOOTER //
// ./src/components/InvestorMainMenuMobile/InvestorMainMenuMobile.jsx